/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date | string; output: Date; }
  DateTime: { input: Date; output: Date; }
  Long: { input: number; output: number; }
  UUID: { input: string; output: string; }
};

export type Query = {
  __typename?: 'Query';
  getCollectionReportOverview: Scalars['String']['output'];
  getPrintMeasurementCard: Scalars['String']['output'];
  getPrintSampleSticker: Scalars['String']['output'];
  getPrintStdGrading: Scalars['String']['output'];
};


export type QueryGetCollectionReportOverviewArgs = {
  filterReportCollectionOverview?: InputMaybe<ReportCollectionOverview>;
};


export type QueryGetPrintMeasurementCardArgs = {
  reportMeasurementCard?: InputMaybe<ReportMeasurementCard>;
};


export type QueryGetPrintSampleStickerArgs = {
  reportSampleSticker?: InputMaybe<ReportSampleSticker>;
};


export type QueryGetPrintStdGradingArgs = {
  reportStdGrading?: InputMaybe<ReportStdGrading>;
};

export type ReportCollectionOverview = {
  brandName: Scalars['String']['input'];
  buyerEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyerNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collectionNames: Array<InputMaybe<Scalars['String']['input']>>;
  collectionNumbers: Array<InputMaybe<Scalars['Int']['input']>>;
  createdBy: Scalars['UUID']['input'];
  createdByName: Scalars['String']['input'];
  deliveryPeriodNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryPeriodNumbers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  isExcel: Scalars['Boolean']['input'];
  productLineNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productLineNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchaseDivisionNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  purchaseDivisionNumbers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  showMarkUp: Scalars['Boolean']['input'];
  showPrice: Scalars['Boolean']['input'];
  sortBy: Scalars['String']['input'];
  statusStyle: Scalars['String']['input'];
  styleCategoryNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  styleCategoryNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  styleNumbers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  supplierNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplierNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReportMeasurementCard = {
  createdBy: Scalars['UUID']['input'];
  measurementCardId: Scalars['String']['input'];
};

export type ReportSampleSticker = {
  createdBy: Scalars['UUID']['input'];
  reportParamId: Scalars['Long']['input'];
  sampleType: Scalars['String']['input'];
};

export type ReportStdGrading = {
  createdBy: Scalars['UUID']['input'];
  stdGradingId: Scalars['String']['input'];
};

export type GetCollectionReportOverviewQueryVariables = Exact<{
  filterReportCollectionOverview: ReportCollectionOverview;
}>;


export type GetCollectionReportOverviewQuery = { __typename?: 'Query', getCollectionReportOverview: string };

export type GetPrintMeasurementCardQueryVariables = Exact<{
  reportMeasurementCard?: InputMaybe<ReportMeasurementCard>;
}>;


export type GetPrintMeasurementCardQuery = { __typename?: 'Query', getPrintMeasurementCard: string };

export type GetPrintSampleStickerQueryVariables = Exact<{
  reportSampleSticker?: InputMaybe<ReportSampleSticker>;
}>;


export type GetPrintSampleStickerQuery = { __typename?: 'Query', getPrintSampleSticker: string };

export type GetPrintStdGradingQueryVariables = Exact<{
  reportStdGrading?: InputMaybe<ReportStdGrading>;
}>;


export type GetPrintStdGradingQuery = { __typename?: 'Query', getPrintStdGrading: string };


export const GetCollectionReportOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCollectionReportOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterReportCollectionOverview"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportCollectionOverview"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCollectionReportOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filterReportCollectionOverview"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterReportCollectionOverview"}}}]}]}}]} as unknown as DocumentNode<GetCollectionReportOverviewQuery, GetCollectionReportOverviewQueryVariables>;
export const GetPrintMeasurementCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPrintMeasurementCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportMeasurementCard"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportMeasurementCard"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPrintMeasurementCard"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportMeasurementCard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportMeasurementCard"}}}]}]}}]} as unknown as DocumentNode<GetPrintMeasurementCardQuery, GetPrintMeasurementCardQueryVariables>;
export const GetPrintSampleStickerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPrintSampleSticker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportSampleSticker"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportSampleSticker"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPrintSampleSticker"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportSampleSticker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportSampleSticker"}}}]}]}}]} as unknown as DocumentNode<GetPrintSampleStickerQuery, GetPrintSampleStickerQueryVariables>;
export const GetPrintStdGradingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPrintStdGrading"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportStdGrading"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportStdGrading"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPrintStdGrading"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportStdGrading"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportStdGrading"}}}]}]}}]} as unknown as DocumentNode<GetPrintStdGradingQuery, GetPrintStdGradingQueryVariables>;